import OriginTree from './Tree';
import TreeNode from './TreeNode';
var Tree = OriginTree;
Tree.TreeNode = TreeNode;
export { TreeNode };
export default Tree;


//////////////////
// WEBPACK FOOTER
// ../~/rc-tree/es/index.js
// module id = 268
// module chunks = 0